import { tv } from "../../variants/tv.js";
const horizonContentfulRichTextVariants = tv({
    slots: {
        root: '@container [&>*:first-child]:mt-0 [&>*:first-child]:pt-0 [&>*:last-child]:mb-0 [&>*:last-child]:pb-0',
        paragraph: '[&_a]:[vertical-align:baseline] [&_a]:[font-size:inherit] [&_a]:[line-height:inherit] [&_a]:[letter-spacing:inherit] [&_a]:text-[inherit]',
        headingH1: '',
        headingH2: '',
        headingH3: '',
        headingH4: '',
        headingH5: '',
        headingH6: '',
        blockquote: 'border-s-1 italic',
        divider: '',
        ul: '',
        ol: '',
        li: '[&_p]:m-0 [&_p]:leading-[inherit]',
        code: 'rounded-md px-1 py-0.5 font-mono',
        figure: '',
        figcaption: 'pt-3 text-body3',
        embed: '',
        table: 'mb-6',
        tableCellContent: '[&_*]:my-0'
    },
    variants: {
        variant: {
            article: {
                paragraph: 'mb-5 text-article2 @2xl:text-article1',
                headingH1: 'pb-6 text-heading2 @2xl:pb-8 @2xl:text-display3',
                headingH2: 'py-5 text-heading3 @2xl:text-heading2',
                headingH3: 'py-3 text-heading4 @2xl:py-4 @2xl:text-heading3',
                headingH4: 'py-2 text-heading5 @2xl:py-3 @2xl:text-article1',
                headingH5: 'py-2 text-heading5',
                headingH6: 'py-2 text-heading6',
                blockquote: 'mt-2 mb-5 ps-5 @2xl:mt-4 @2xl:ps-7',
                divider: 'py-7 @2xl:py-8',
                ul: 'mb-5 text-article2 @2xl:text-article1',
                ol: 'mb-5 text-article2 @2xl:text-article1',
                li: 'mb-1 @2xl:mb-2',
                table: '[&_thead_th>div>div_p]:!text-heading6 @2xl:[&_thead_th>div>div_p]:!text-heading5',
                tableCellContent: 'text-body2 @2xl:text-body1 [&_p]:text-body2 @2xl:[&_p]:text-body1',
                figure: 'mb-5 pt-1 @2xl:pt-2',
                embed: 'mb-5'
            },
            marketing: {
                paragraph: 'mb-3 text-body2 @2xl:mb-4 @2xl:text-body1',
                headingH1: 'pb-6 text-heading2',
                headingH2: 'py-5 text-heading3',
                headingH3: 'py-3 text-heading4',
                headingH4: 'py-2 text-heading5',
                headingH5: 'py-2 text-heading5',
                headingH6: 'py-2 text-heading6',
                blockquote: 'mt-2 mb-5 ps-5',
                divider: 'py-7',
                ul: 'mb-5 text-body1',
                ol: 'mb-5 text-body1',
                li: 'mb-1',
                table: '[&_thead_th>div>div_p]:!text-heading6',
                tableCellContent: 'text-body2 [&_p]:text-body2',
                figure: 'mb-5 pt-1',
                embed: 'mb-5'
            }
        },
        emphasis: {
            regular: {
                root: 'text-neutral-13',
                blockquote: 'border-primary-8',
                code: 'bg-neutral-3 text-neutral-13',
                figcaption: 'text-neutral-10',
                table: "[&_thead_th]:text-neutral-13 [&_tr]:bg-neutral-1 [&_table]:divide-neutral-5 [&_thead]:border-neutral-5 [&_td]:border-primary-5 [&_th]:border-primary-5 [&_tr]:hover:bg-neutral-2 [&_tr]:active:bg-primary-3 [&_th]:hover:bg-neutral-2 [&_th]:active:bg-neutral-4"
            },
            medium: {
                root: 'text-primary-13',
                blockquote: 'border-primary-8',
                code: 'bg-primary-4 text-primary-13',
                figcaption: 'text-primary-10',
                table: "[&_thead_th]:text-primary-13 [&_tr]:bg-primary-3 [&_table]:divide-primary-5 [&_thead]:border-primary-5 [&_td]:border-primary-5 [&_th]:border-primary-6 [&_tr]:hover:bg-primary-4 [&_tr]:active:bg-primary-5 [&_th]:hover:bg-primary-4 [&_th]:active:bg-primary-5"
            },
            bold: {
                root: 'text-primary-1',
                blockquote: 'border-primary-5',
                code: 'bg-primary-10 text-primary-1',
                figcaption: 'text-primary-4',
                table: "[&_thead_th]:text-primary-3 [&_tr]:bg-primary-12 [&_table]:divide-primary-9 [&_thead]:border-primary-9 [&_td]:border-primary-9 [&_th]:border-primary-9 [&_tr]:hover:bg-primary-11 [&_tr]:active:bg-primary-10 [&_th]:hover:bg-primary-11 [&_th]:active:bg-primary-10"
            }
        }
    },
    defaultVariants: {
        variant: 'article',
        emphasis: 'regular'
    }
});
export { horizonContentfulRichTextVariants };
